import React from 'react';
import styles from './LearningReportCard.module.css';
import type { ForemanLearningReport } from '../../types/foreman';

interface LearningReportCardProps {
  report: ForemanLearningReport;
}

function getTrendClass(trend: string): string {
  const t = trend.toLowerCase();
  if (t === 'improving') return styles.trendImproving;
  if (t === 'stable') return styles.trendStable;
  return styles.trendDeclining;
}

function getTrendIcon(trend: string): string {
  const t = trend.toLowerCase();
  if (t === 'improving') return '\u2191';
  if (t === 'stable') return '\u2192';
  return '\u2193';
}

const LearningReportCard: React.FC<LearningReportCardProps> = ({ report }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.icon}>{'\u{1F4CA}'}</span>
        <div className={styles.headerText}>
          <span className={styles.headerLabel}>Learning Report</span>
          <span className={styles.period}>{report.period}</span>
        </div>
      </div>

      <div className={styles.stats}>
        <div className={styles.stat}>
          <span className={styles.statValue}>{report.corrections}</span>
          <span className={styles.statLabel}>Corrections</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.statValue}>{report.practices}</span>
          <span className={styles.statLabel}>Practices</span>
        </div>
      </div>

      <div className={styles.footer}>
        <span className={`${styles.trendPill} ${getTrendClass(report.trend)}`}>
          {getTrendIcon(report.trend)} {report.trend}
        </span>
        {report.accuracy && (
          <span className={styles.accuracyPill}>
            Accuracy: {report.accuracy}
          </span>
        )}
      </div>
    </div>
  );
};

export default LearningReportCard;
